export const USER = 'user';
export const LOCAL_ACCESS_TOKEN_EXPIRY_TIME = 'wedge_token_expiry_time';
export const LOCAL_ACCESS_TOKEN_KEY = 'wedge_access_token';
export const LOCAL_CUSTOMER_KEY = 'wedge_customer_key';
export const PAYMENT = 'payment';
export const POLICY_THREAT = 'Threat Protection';
export const INACCESSIBLE = 'inaccessible';
export const EMPTY_EMAIL_ERROR = 'Email not found';
export const LDAP_STATUS_LOADING = 'Loading...';
